import { render } from "./Payoff.vue?vue&type=template&id=028bc4c8"
import script from "./Payoff.vue?vue&type=script&lang=js"
export * from "./Payoff.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__